// assets/async-scripts-loader.js
// Load this after theme.js to defer non-critical scripts

(function() {
    // Wait for page to be interactive
    const loadWhenIdle = (callback) => {
        if ('requestIdleCallback' in window) {
            requestIdleCallback(callback, { timeout: 2000 });
        } else {
            setTimeout(callback, 100);
        }
    };
    
    // Defer Facebook Pixel if it exists
    if (typeof fbq === 'undefined' && !window._fbq) {
        loadWhenIdle(() => {
            // Facebook Pixel will load via its own script - just mark as ready
            if (window.fbq) {
                console.debug('Facebook Pixel loaded deferred');
            }
        });
    }
    
    // Defer Google Tag Manager initialization
    if (typeof dataLayer === 'undefined' && !window.google_tag_manager) {
        loadWhenIdle(() => {
            // GTM initializes itself - just ensuring it runs after critical content
            if (window.gtag) {
                console.debug('Google Tag Manager loaded deferred');
            }
        });
    }
    
    // Defer Microsoft Clarity
    if (typeof clarity === 'undefined') {
        loadWhenIdle(() => {
            // Clarity loads via its own script
            if (window.clarity) {
                console.debug('Clarity loaded deferred');
            }
        });
    }
})();